import api from './api';

export interface OrderItemPayload {
  sku: string;
  title: string;
  brand: string;
  color?: string;
  qty: number;
  prezzoUnitario: number;
  percentualeSconto: number;
  totaleLinea: number;
}

export interface AddressPayload {
  label?: string;
  nominativo: string;
  telefono?: string;
  address: string;
  city: string;
  province?: string;
  cap: string;
}

export interface OrderCreatePayload {
  idCliente?: number;
  items: OrderItemPayload[];
  indirizzoSpedizione: AddressPayload;
  idModalitaSpedizione: number;
  idCondizionePagamento: number;
  imponibile: number;
  iva: number;
  speseSpedizione: number;
  note?: string;
  coupon?: string;
  confermaIncongruenze?: boolean;
}

export interface OrderResponse {
  idOrdine: number;
  guid: string;
  numeroOrdine: string;
  /** Il numero del gestionale (`OW/2026/00048`), quello di "I miei ordini"
   *  (INT-134); `numeroOrdine` è il riferimento web. */
  numeroGestionale?: string | null;
  idUser: string;
  idCliente?: number;
  idStatoOrdine: number;
  imponibile: number;
  iva: number;
  totaleOrdine: number;
  speseSpedizione: number;
  dataOrdine: string;
  items: OrderItemPayload[];
  note?: string;
  coupon?: string;
  /** L'ordine su NTS: `key` apre il suo dettaglio in "I miei ordini". */
  erp?: { status?: string; key?: { et_tipork: string; et_anno: number; et_serie: string; et_numdoc: number } } | null;
}

export const orderService = {
  async create(payload: OrderCreatePayload): Promise<OrderResponse> {
    const { data } = await api.post<OrderResponse>('/api/orders', payload);
    return data;
  },
};
